import { u } from "../_ui-71f9b37c.mjs";
import "../_i18n-e414d464.mjs";
import "../index-64135f7d.mjs";
import "../index-703c58ee.mjs";
import "vue";
import "../index-38c53cf2.mjs";
import "../i18n-35335a5c.mjs";
import "../malarkeyTwilioAdapter-1c296255.mjs";
import "../index-13be80af.mjs";
import "../_commonjsHelpers-ca272635.mjs";
import "../_debug-8b5c3032.mjs";
import "joi";
import "../helpers-674591c1.mjs";
import "../event-socket/malarkeyEventSocketAdapter.es.js";
import "../otpauth.esm-675c01d0.mjs";
import "../sudo-bad5b55e.mjs";
import "../index-fd2245c5.mjs";
const isVirtualKeyboardVisible = () => {
  if ("undefined" === typeof window || !("visualViewport" in window) || null === window.visualViewport || !("document" in window) || !("documentElement" in window.document) || !("clientHeight" in window.document.documentElement)) {
    return void 0;
  }
  const { height: viewportHeight } = window.visualViewport;
  const { clientHeight: documentClientHeight } = window.document.documentElement;
  return viewportHeight < documentClientHeight;
};
let lastKeyboardVisibleState;
let nativeEventTimeout;
let touchStartedAt;
const onTouchStart = (e) => {
  if (e.touches.length === 1) {
    touchStartedAt = Date.now().valueOf();
  }
};
const onTouchEnd = (e) => {
  const now = Date.now().valueOf();
  if (touchStartedAt && now - touchStartedAt > 500) {
    window.dispatchEvent(
      new CustomEvent("longtouch", { detail: e })
    );
    touchStartedAt = void 0;
  }
};
const onTouchCancel = () => {
  touchStartedAt = void 0;
};
const hookVirtualKeyboardEvents = (window2) => {
  if ("undefined" === typeof window2) {
    return;
  }
  const nativeEventHandler = () => {
    const keyboardVisibleState = isVirtualKeyboardVisible();
    if (keyboardVisibleState !== lastKeyboardVisibleState) {
      lastKeyboardVisibleState = keyboardVisibleState;
      window2.dispatchEvent(
        new CustomEvent("virtualkeyboard:change", {
          detail: {
            visible: keyboardVisibleState
          }
        })
      );
      if (lastKeyboardVisibleState === true) {
        window2.dispatchEvent(new CustomEvent("virtualkeyboard:show"));
      } else if (lastKeyboardVisibleState === false) {
        window2.dispatchEvent(new CustomEvent("virtualkeyboard:hide"));
      } else {
        window2.dispatchEvent(new CustomEvent("virtualkeyboard:unknown"));
      }
    }
  };
  const onNativeEvent = () => {
    if (nativeEventTimeout) {
      clearTimeout(nativeEventTimeout);
    }
    nativeEventTimeout = setTimeout(nativeEventHandler);
  };
  window2.addEventListener("resize", onNativeEvent);
  window2.addEventListener("scroll", onNativeEvent);
  window2.addEventListener("focus", onNativeEvent);
  window2.addEventListener("blur", onNativeEvent);
  window2.addEventListener("touchstart", onNativeEvent);
  window2.addEventListener("touchend", onNativeEvent);
  window2.addEventListener("orientationchange", onNativeEvent);
  if ("visualViewport" in window2 && null !== window2.visualViewport) {
    window2.visualViewport.addEventListener("resize", onNativeEvent);
    window2.visualViewport.addEventListener("scroll", onNativeEvent);
  }
  window2.addEventListener("touchstart", onTouchStart);
  window2.addEventListener("touchend", onTouchEnd);
  window2.addEventListener("touchcancel", onTouchCancel);
};
export {
  u as MalarkeyCoreUiPlugin,
  hookVirtualKeyboardEvents,
  isVirtualKeyboardVisible
};
//# sourceMappingURL=ui.es.js.map
